export const BRANCH_SUCCESS = 'BRANCH_SUCCESS';
export const BRANCH_LOADING = 'BRANCH_LOADING';
export const BRANCH_SHOW_MODAL = 'BRANCH_SHOW_MODAL';
export const BRANCH_HIDE_MODAL = 'BRANCH_HIDE_MODAL';
export const BRANCH_FAILED = 'BRANCH_FAILED';
export const BRANCH_LOAD = 'BRANCH_LOAD';
export const BRANCH_CREATE = 'BRANCH_CREATE';
export const BRANCH_UPDATE = 'BRANCH_UPDATE';



